export default __webpack_public_path__ + "static/media/1-3.299708c5.jpg";